









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AsideTools extends Vue {
  @Prop({
    default: null,
  })
  public icon!: string;

  @Prop({
    default: null,
  })
  public label!: string;
}
